// extracted by mini-css-extract-plugin
module.exports = {"upload_des":"HeadImgList_style_upload_des__3w1Bs","upload_add":"HeadImgList_style_upload_add__1rsbS","text_desc":"HeadImgList_style_text_desc__1YYi1"};